'use client'

import { useEffect, useState } from 'react'

/**
 * The viewer's IANA timezone, for rendering event times against their own
 * clock rather than the zone an event happens to be stored in.
 *
 * Returns `undefined` until after mount: reading `Intl` during render would
 * produce server markup in the server's zone and client markup in the
 * viewer's, which React reports as a hydration mismatch. Callers should fall
 * back to the event's stored zone in the meantime — `formatTime(t.startsAt,
 * localTz ?? t.timezone)` — so the first paint is still a correct rendering of
 * the same instant, just labelled in the event's zone.
 */
export function useLocalTimezone(): string | undefined {
  const [tz, setTz] = useState<string | undefined>(undefined)
  useEffect(() => {
    setTz(Intl.DateTimeFormat().resolvedOptions().timeZone)
  }, [])
  return tz
}
